var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import IconEye from '../icons/IconEye';
import IconEyeClosed from '../icons/IconEyeClosed';
var InputField = React.forwardRef(function (_a, ref) {
    var label = _a.label, type = _a.type, placeholder = _a.placeholder, labelClass = _a.labelClass, inputClass = _a.inputClass, readOnly = _a.readOnly, id = _a.id, error = _a.error, secondaryAction = _a.secondaryAction, props = __rest(_a, ["label", "type", "placeholder", "labelClass", "inputClass", "readOnly", "id", "error", "secondaryAction"]);
    var _b = React.useState(false), showPassword = _b[0], setShowPassword = _b[1];
    return (_jsxs("div", { children: [label && (_jsxs("div", { className: 'vas-flex vas-justify-between', children: [_jsxs("label", { className: "".concat(labelClass, " vas-text-vastypographyLabelsTextColor vas-text-vastypographyLabelsFontSize vas-font-vastypographyLabelsFontWeight"), htmlFor: id, children: [label, " ", props.required && _jsx("span", { className: 'vas-text-vasDanger', children: "*" })] }), secondaryAction] })), _jsxs("div", { className: 'vas-relative', children: [_jsx("input", __assign({ ref: ref, id: id, type: type === 'password' ? (showPassword ? 'text' : 'password') : type, placeholder: placeholder, className: "!vas-mt-0 ".concat(inputClass), readOnly: readOnly }, props)), type === 'password' && (_jsx("div", { className: 'vas-absolute vas-top-1/3 vas-right-4', children: _jsx("div", { children: showPassword ? (_jsx(IconEye, { onClick: function () { return setShowPassword(!showPassword); } })) : (_jsx(IconEyeClosed, { onClick: function () { return setShowPassword(!showPassword); } })) }) }))] }), error && (_jsx("p", { className: 'vas-text-vasDanger vas-text-vastypographyLabelsFontSize', children: error.message }))] }));
});
// Make sure to display the name of the component for debugging
InputField.displayName = 'InputField';
export default InputField;
